module.exports = __webpack_public_path__ + "assets/new-close.7d4bfd8a5479c680925696772922bfd6.png";